export default __webpack_public_path__ + "static/media/chevron-down.34a96496.svg";